import React from 'react';
import styles from './AdminDashboardPage.module.scss';
const AdminDashboardPage = () => {
  return (
    <div className={styles.dashboardContainer}>
      <h1>Chào Mừng Tới Trang Quản Trị</h1>
      <p>Đây là khu vực được bảo vệ. Từ đây bạn có thể quản lý sản phẩm, đơn hàng...</p>
    </div>
  );
};

export default AdminDashboardPage;